import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-xl border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1440px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-1.5 font-heading font-semibold text-[16px] text-foreground-950 whitespace-nowrap"
          >
            cssspreadsheet.rest
            <span className="w-[4px] h-[4px] rounded-full bg-primary-500 inline-block ml-0.5"></span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap cursor-pointer bg-background-50"
              >
                Categories
                <i className={dropdownOpen ? 'ri-arrow-up-s-line text-base transition-transform duration-200' : 'ri-arrow-down-s-line text-base transition-transform duration-200'}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 bg-background-50 border border-background-200/70 rounded-2xl shadow-lg p-4 w-[560px] z-50 grid grid-cols-2 gap-1 animate-fade-in">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setDropdownOpen(false)}
                      className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-foreground-700 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-right-up-line text-foreground-500 text-sm"></i>
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              CSSBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 animate-fade-in">
          <div className="grid grid-cols-2 gap-1 max-w-[1440px] mx-auto">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
                {cat.name}
              </a>
            ))}
          </div>
          <div className="mt-3 pt-3 border-t border-background-200/70">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="block w-full text-center px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              CSSBuy Sheet
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}